import { Middleware, MiddlewareAPI } from 'redux';
import { get, isObject, without, first } from 'lodash';

import { MERGE_COMPONENT_SETTING_IN_STORE } from '../../../../common/actions/settings';
import * as membersPageSelectors from '../../../../common/state/members-page/selectors';
import * as siteSelectors from '../../../../common/state/site/selectors';
import * as membersPageActions from '../../../../common/state/members-page/actions';
import { getComponentSettings } from '../../../../common/selectors/settings-selectors';
import { MembersState, Action, ThunkAction } from '../..';

export const createRoleFilterChangeMiddleware = (): Middleware => {
  return (api: MiddlewareAPI<MembersState>) => (next) => (action: Action | ThunkAction) => {
    if (isHiddenFiltersBeingChanged(action as Action)) {
      const state = api.getState();
      const hiddenFilters = getHiddenFilters(action as Action);
      const oldHiddenFilters = getComponentSettings(state).hiddenFilters;
      const currentFilter = membersPageSelectors.getFilter(state);
      const filters = siteSelectors.getFilters(state);

      const newFilter = hiddenFilters.includes(currentFilter)
        ? getFirstVisibleFilter(hiddenFilters, filters)
        : getNoLongerHiddenFilter(hiddenFilters, oldHiddenFilters);

      api.dispatch(membersPageActions.setMembersFilterAndFetch(newFilter));
    }

    return next(action as Action);
  };
};

const isHiddenFiltersBeingChanged = (action: Action) =>
  action.type === MERGE_COMPONENT_SETTING_IN_STORE && isObject(action.payload) && !!getHiddenFilters(action);

const getHiddenFilters = (action: Action) => get(action.payload, 'hiddenFilters');

const getNoLongerHiddenFilter = (hiddenFilters: string[], oldHiddenFilters: string[]) =>
  first(without(oldHiddenFilters, ...hiddenFilters));

const getFirstVisibleFilter = (hiddenFilters: string[], filters: object) =>
  Object.keys(filters)
    .filter((f) => !hiddenFilters.includes(f))
    .shift();
